module.exports = __webpack_public_path__ + "img/nanny.4bef0437.png";